import {DependencyList, useEffect, useRef, useContext} from 'react';
import {StompSubscription} from '@stomp/stompjs';
import {CarecoApiContext} from '@/app-context/careco-api-context';

export function useWebSocketSubscription(
  subscribe: () => StompSubscription | undefined,
  subscribeDeps: DependencyList = [],
  deps: DependencyList = [],
) {
  const subscription = useRef<StompSubscription>(null);
  const { webSocketApi } = useContext(CarecoApiContext);

  useEffect(() => {
    if (!subscription.current && webSocketApi?.isReady()) {
      subscription.current = subscribe() ?? null;
    }
  }, [subscription.current, webSocketApi, ...subscribeDeps ?? [], ...deps ?? []]);

  useEffect(() => {
    return () => {
      subscription.current?.unsubscribe();
      subscription.current = null;
    };
  }, deps);
}
